import React from 'react'

export interface ReplyQuoteIconProps extends React.SVGProps<SVGSVGElement> {
    size?: number
    strokeWidth?: number
}

// The round reply bubble (lucide's `message-circle`, as ReplyIcon draws it)
// with lucide's `quote` marks set small in its centre: a reply that quotes.
// The bubble's circle is centred on (12, 12), so the marks sit in the middle of
// the bubble rather than of the tail. At this size the marks read as solid
// glyphs, so they are filled rather than stroked. Same props as a lucide icon.
export default function ReplyQuoteIcon({
    size = 24,
    strokeWidth = 2,
    className,
    ...props
}: ReplyQuoteIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...props}
        >
            <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
            <svg
                x="8"
                y="8"
                width="8"
                height="8"
                viewBox="0 0 24 24"
                fill="currentColor"
                stroke="none"
            >
                <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" />
                <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" />
            </svg>
        </svg>
    )
}
